import { render, staticRenderFns } from "./CardBalance.vue?vue&type=template&id=4ef48f6d&scoped=true&"
import script from "./CardBalance.vue?vue&type=script&lang=ts&"
export * from "./CardBalance.vue?vue&type=script&lang=ts&"
import style0 from "./CardBalance.vue?vue&type=style&index=0&id=4ef48f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef48f6d",
  null
  
)

export default component.exports